<template>
    <div class="wrapper">
        <h1>{{ $t('labels.select_row') }}</h1>

        <template v-if="showRowsAsButtons">
            <div class="button-grid">
                <button
                    type="button"
                    :class="getButtonClasses(row)"
                    v-for="row in visible"
                    :key="row.id"
                    :style="'background: ' + (row.color ? row.color : '#0a8bc8')"
                    @click="selectRow(row)"
                    v-text="row.title"
                ></button>
            </div>

            <div class="app-actions">
                <div class="col-md-4">
                    <cancel-button :redirect="cancelRedirect()"></cancel-button>
                </div>
            </div>
        </template>

        <template v-else>
            <input type="number" name="row" id="row" class="form-control form-control--large" v-model="value" disabled>

            <div class="row">
                <div class="col-md-4">
                    <cancel-button :redirect="cancelRedirect()"></cancel-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CancelButton from "../components/app/CancelButton";
import {writeTrackLog} from "../utils/tracking";

export default {
  name: 'choose-row',

  components: {CancelButton},

  data() {
    return {
      value: ''
    }
  },

  computed: {
    currentDevice() {
      return this.$store.state.currentDevice;
    },

    currentEmployee() {
      return this.$store.state.currentEmployee;
    },

    currentActivity() {
      return this.$store.getters.currentActivityForEmployee;
    },

    rows() {
      return this.$store.state.rows
    },

    rowsOrder() {
      return this.$store.state.rowsOrder;
    },

    visible() {
      const ordered = this.rowsOrder
          ? this.rowsOrder.split('|')
          : this.currentDevice && this.currentDevice.rows_order ? this.currentDevice.rows_order : [];

      return this.rows
          .filter(row => ordered.indexOf(row.id.toString()) > -1)
          .map(row => {
            row.order = ordered.indexOf(row.id.toString());

            return row;
          })
          .sort((a, b) => {
            if (a.order > b.order) return 1;
            if (a.order < b.order) return -1;
            return 0;
          });
    },

    showRowsAsButtons() {
      return this.$store.state.rowsAsButtons;
    }
  },

  methods: {
    getButtonClasses(row) {
      return {
        'action-button': true,
        'button-grid-button': true,
        'active': this.currentActivity && this.currentActivity.row_id && row.id === this.currentActivity.row_id
      };
    },

    selectRow(row) {
      if (this.$store.state.enableTracking) writeTrackLog("Select row by button: " + row.title);

      this.updateActivity(row);
    },

    updateActivity(row) {
      this.$store.dispatch('updateActivity', {id: this.currentActivity.id, row_id: row.id, row: row});

      if (this.$parent.preRegistering) return this.$store.commit('setChecked');

      const route = this.$parent.determineRoute(this.currentActivity);

      if (route !== null && route !== undefined) return this.$router.push(route);

      this.$router.push('activity');
    },

    cancelRedirect() {
      if (this.$store.state.enableTracking) writeTrackLog("Cancel from: " + this.$route.name);

      if (this.currentActivity) {
        const activity = this.$store.getters.activityById(this.currentActivity.activity_id);

        if (this.currentDevice.pre_register_activities) {
          if (activity.register_package_types) return {name: 'packaging'};
          if (activity.register_team_numbers) return {name: 'team'};
        } else {
          if (activity.register_amounts) return {name: 'amount'};
          if (activity.register_package_types) return {name: 'packaging'};
          if (activity.register_team_numbers) return {name: 'team'};
        }
      }

      return {name: 'activity'};
    }
  },

  mounted() {
    if (this.$store.state.enableTracking) writeTrackLog("VIEW: Select row");

    if (this.currentEmployee === null || this.currentEmployee === undefined) return this.$router.push({name: 'pin'});

    if (!this.showRowsAsButtons) {
      if (this.currentActivity !== null && this.currentActivity !== undefined && this.currentActivity.row_id !== null) {
        this.value = this.currentActivity.row.title;
      }

      window.events.$emit('enableNumpad');
    }

    window.events.$on('numpadType', value => {
      if (document.getElementById('row')) this.value = this.value + value;
    });

    window.events.$on('backspace', () => {
      if (document.getElementById('row')) this.value = '';
    });

    window.events.$on('submitFromNumpad', () => {
      const field = document.getElementById('row');

      if (!this.showRowsAsButtons && (field === null || field === undefined || this.value === '')) return;

      const row = this.$store.getters.rowByTitle(parseInt(this.value, 10));

      if (!row) {
        this.value = '';
        return this.$store.dispatch('setError', this.$t('errors.row_not_found'));
      }

      if (this.$store.state.enableTracking) writeTrackLog("Select row by typing: " + row.title);

      this.updateActivity(row);
    })
  },

  beforeDestroy() {
    window.events.$off('submitFromNumpad');
    window.events.$off('backspace');
    window.events.$off('numpadType');
  }
}
</script>


